import log from '@/plugin/logger.ts'

/**
 * STATE
 */
const state = {
  localSession : {},
  isSignedIn : false
}

/**
 * GETTERS
 */
const getters = {
  getLocalSession(state) {
    return state.localSession
  },
  getSessionStatus(state) {
    return state.isSignedIn
  },
  getUserId(state) {
    return state.localSession.memberId
  },
  getBannerStatus(state) {
    return state.banner
  }
}

/**
 * MUTATIONS
 */
const mutations = {
  // parcel registration
  mutateCustomerInfo(state, value = {}) {

    log.debug("mutations / mutateCustomerInfo excuted => ", value)

    // 기존 세션정보를 복사
    const tempSession = { ...state.localSession }

    // 전달받은 값으로 세션정보 업데이트
    Object.keys(value).forEach(key => {
      if (value[key] !== undefined) {
        tempSession[key] = value[key]
      }
    })

    state.localSession  = tempSession
    state.isSignedIn    = true
  },

  destroyCustomerInfo(state){
    log.debug("destroyCustomerInfo excuted = > ")

    state.localSession = {}
    state.isSignedIn = false
  },
}

/**
 * ACTIONS
 */
const actions = {
  // 로그인 이후 조회된 고객의 정보를 vuex에 넣어 활용 가능하도록 한다.
  setCustomerInfo: ({ commit }, payload) => {
    // log.debug(payload)
    commit('mutateCustomerInfo', payload)
  },
  // 로그아웃 후 vuex에 저장 되어 있는 고객의 정보를 지운다.
  destroyCustomerInfo: ({ commit, state }) => {
    log.debug(state)
    commit('destroyCustomerInfo')
  },

  // 배너의 쿠키정보를 활용한다.
  bannerStatus: ({ commit }) => {
    commit('mutBannerStatus')
  }
}

// state, getters, mutations, actions, modules
export default {

  state: {
    ...state
  },
  getters,
  mutations,
  actions

}
